import SettingLabel from '../views/setting/LabelPage.vue';
import SettingSpace from '../views/setting/SpacePage.vue';
import SettingPro from '../views/setting/ProfessionalPage.vue';
import SettingAccount from '../views/setting/AccountPage.vue';
import SettingAccounting from '../views/setting/AccountingPage.vue';
import SettingProject from '../views/setting/ProjectPage.vue';
import SettingOrganization from '../views/setting/OrganizationPage.vue';
import SettingRecordDownload from '../views/setting/RecordDownloadPage.vue';
import SettingAppointmentDownload from '../views/setting/AppointmentDownloadPage.vue';
import SettingReceiptDownload from '../views/setting/ReceiptDownloadPage.vue';
import SettingActivityDownload from '../views/setting/ActivityDownloadPage.vue';
import SettingMailRecord from '../views/setting/MailRecordPage.vue';
import SettingDebugging from '../views/setting/DebuggingPage.vue';
import SettingSystem from '../views/setting/SystemSettingPage.vue';

export default [
  {
    path: 'label',
    name: 'SettingLabel',
    title: '標籤設定',
    component: SettingLabel,
    showInMenu: true,
  },
  {
    path: 'accounting',
    name: 'Accounting',
    title: '分帳模組',
    component: SettingAccounting,
    showInMenu: true,
    adminOnly: true,
  },
  {
    path: 'pro',
    name: 'SettingPro',
    title: '專業人士',
    component: SettingPro,
    showInMenu: true,
  },
  {
    path: 'space',
    name: 'SettingSpace',
    title: '空間設定',
    component: SettingSpace,
    showInMenu: true,
    adminOnly: true,
  },
  {
    path: 'organization',
    name: 'SettingOrganization',
    title: '專案設定',
    component: SettingOrganization,
    showInMenu: true,
  },
  {
    path: 'organization/:oid',
    props: true,
    name: 'SettingOrganizationProject',
    title: '專案設定',
    component: SettingProject,
    showInMenu: false,
  },
  {
    path: 'account',
    name: 'SettingAccount',
    title: '帳號設定',
    component: SettingAccount,
    showInMenu: true,
  },
  {
    path: 'record-download',
    name: 'RecordDownload',
    title: '個案記錄下載',
    component: SettingRecordDownload,
    showInMenu: true,
  },
  {
    path: 'appointment-download',
    name: 'AppointmentDownload',
    title: '預約紀錄下載',
    component: SettingAppointmentDownload,
    showInMenu: true,
  },
  {
    path: 'activity-download',
    name: 'ActivityDownload',
    title: '活動下載',
    component: SettingActivityDownload,
    showInMenu: true,
  },
  {
    path: 'receipt-download',
    name: 'ReceiptDownload',
    title: '收據下載',
    component: SettingReceiptDownload,
    showInMenu: true,
    adminOnly: true, // 後端 /v1/export_receipts 限 admin
  },
  {
    path: 'mail-record',
    name: 'MailRecord',
    title: 'Email 寄送紀錄',
    component: SettingMailRecord,
    showInMenu: true,
    adminOnly: true, // 後端 /v1/log/email 限 admin
  },
  {
    path: 'system',
    name: 'SettingSystem',
    title: '系統設定',
    component: SettingSystem,
    showInMenu: true,
    adminOnly: true, // 後端 /v1/system-settings 限 admin
  },
  {
    // 隱藏頁面：不在側欄顯示，只能由網址 #/debugging（或 #/setting/debugging）進入，
    // 且僅限 admin，頁面本身會把其他角色導回 /reserve
    path: 'debugging',
    alias: '/debugging',
    name: 'SettingDebugging',
    title: '除錯',
    component: SettingDebugging,
    showInMenu: false,
    adminOnly: true,
  },
];
